import { isBoolean } from 'lodash'
import slugify from 'slugify'
import { getMimeTypeFromExtension } from '@/lib/file-types'
import generateMapImageUrl from '@/lib/map-image'

export const formatImageUrl = fileRef => {
  return `${process.env.VUE_APP_ASSETS_BASE_URL}/${fileRef}`
}

export const formatImageThumbnailUrl = fileRef => {
  return `${process.env.VUE_APP_ASSETS_BASE_URL}/hc_${fileRef}`
}

export const formatImgixUrl = file => {
  const { fileRef } = file

  return formatUrl(`${process.env.VUE_APP_IMGIX_BASE_URL}/${fileRef}`, {
    query: {
      fit: 'cover',
      w: 560,
      h: 400
    }
  })
}

export const formatUrl = (url, options = {}) => {
  const formattedUrl = new URL(url)

  const { query } = options

  if (query) {
    Object.keys(query).forEach(key => {
      if (query[key] || isBoolean(query[key])) {
        formattedUrl.searchParams.set(key, query[key])
      }
    })
  }

  return formattedUrl.toString()
}

export const formatVideoImageUrl = video => {
  if (!video?.thumbnail) {
    return null
  }

  // const gifUrl = thumbnail?.replace(/\.jpg$/, '.gif')

  return formatUrl(video.thumbnail, {
    query: {
      time: '1s',
      height: 400,
      duration: '4s'
    }
  })
}

export const toSlug = (text, options = {}) => {
  return slugify(text, { lower: true, ...options })
}

export const formatMapImageUrl = (data, options = {}) => {
  const { listingRef, country, region } = data

  return generateMapImageUrl({
    width: options.width || 1200,
    height: options.height || 800,
    zoom: options.zoom || 8,
    country: country || 'united-kingdom',
    region: region || null,
    kmRadius: options.radius || null,
    listingRef: listingRef || null
  })
}

export const getFilePreviewUrl = file => {
  return URL.createObjectURL(file)
}

export const getFileType = file => {
  if (!file?.extension) {
    return null
  }

  const { extension } = file

  if (extension) {
    return getMimeTypeFromExtension(extension)
  } else {
    return null
  }
}

export const getFileBase64 = (file, options = {}) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      if (options.legacy) {
        /* odd legacy api workaround */
        resolve(reader.result.split(',')[1])
      } else {
        resolve(reader.result)
      }
    }
    reader.onerror = error => reject(error)
  })
}
